import React, { useEffect } from 'react';
import { Warning } from '@phosphor-icons/react';
import { useOneButtonStore } from '../../../../store/oneButtonStore';
import { usePartnerApiErrorStore } from '../../../../store/partnerApiErrorStore';
import { registerPartnerApiErrorInterceptor } from '../../../../helpers/partnerApiErrorInterceptor';
import DashboardModal from './DashboardModal';
import { OBD_OPPORTUNITY_ASSISTANT_DRAWER_Z } from './oneButtonOverlayZ';
import './oneButton-css/PartnerApiErrorModal.css';

/**
 * Global popup for finance partner / OneBUTTON contract API failures.
 * Registered once via axios response interceptor.
 */
export const PartnerApiErrorModal: React.FC = () => {
    const theme = useOneButtonStore((s) => s.theme);
    const popup = usePartnerApiErrorStore((s) => s.popup);
    const clearPartnerApiErrorPopup = usePartnerApiErrorStore((s) => s.clearPartnerApiErrorPopup);

    useEffect(() => {
        registerPartnerApiErrorInterceptor();
    }, []);

    const open = popup != null;
    const title = popup?.title ?? 'Request failed';
    const message = popup?.message ?? '';

    return (
        <DashboardModal
            open={open}
            onClose={clearPartnerApiErrorPopup}
            title={
                <>
                    <Warning weight="fill" aria-hidden className="obd-partner-error-modal__icon" />
                    <span>{title}</span>
                </>
            }
            width={480}
            centered
            zIndex={OBD_OPPORTUNITY_ASSISTANT_DRAWER_Z + 10}
            theme={theme}
            className={`obd-partner-error-modal obd-theme-${theme}`}
            rootClassName={`obd-partner-error-modal-root obd-theme-${theme}`}
            maskClosable
            destroyOnClose
            footer={
                <div className="obd-partner-error-modal__footer">
                    <button
                        type="button"
                        className="obd-sync-modal__btn obd-sync-modal__btn--primary"
                        onClick={clearPartnerApiErrorPopup}
                    >
                        OK
                    </button>
                </div>
            }
        >
            <div className="obd-partner-error-modal__body">
                <p className="obd-partner-error-modal__message">{message}</p>
                {popup?.detail ? (
                    <p className="obd-partner-error-modal__detail">{popup.detail}</p>
                ) : null}
            </div>
        </DashboardModal>
    );
};

export default PartnerApiErrorModal;
